// Meta's in-app browsers (FB/IG) and generic Android WebViews ("; wv)") keep a
// cookie jar isolated from the real browser, so the Google Pay sheet opens to a
// Google sign-in wall instead of the shopper's saved cards -- a prime suspect
// for repeated quick cancels. Tag beacons with this so the correlation is
// queryable without per-session UA digging. Kept standalone (no coupling to a
// specific beacon) so any tracker can reuse it.
export var isInAppWebview = function isInAppWebview() {
  if (typeof navigator === "undefined") return false;
  return /FB_IAB|FBAN|FBAV|Instagram|; wv\)/i.test(navigator.userAgent || "");
};